// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__34-_W","Item":"Tabs_Item__30fSU","Active":"Tabs_Active__2yZhX"};